import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { AuthService } from '../../../auth.service';
import { StateService } from '../state.service';
import { Subject } from 'rxjs';
import { FormService } from '../../../form.service';

@Component({
    selector: 'app-signing',
    templateUrl: './signing.component.html',
    styleUrls: ['./signing.component.scss']
})
export class SigningComponent implements OnInit, OnDestroy {

    public source: object;
    public formCode: string;

    private destroy$ = new Subject<boolean>();
    constructor(private route: ActivatedRoute, private auth: AuthService,
        private stateService: StateService, private formService: FormService) { }

    ngOnInit() {
        this.route.parent.params
        .takeUntil(this.destroy$)
        .subscribe(data => {
            this.formCode = data['formCode'];
            this.source = {
                url: `${environment.api}/opdrachtformulieren/${this.formCode}/pdf/gevuld`,
                httpHeaders: {
                    Authorization: `Bearer ${this.auth.getToken()}`
                }
            }
        });

        this.stateService.updateAdministrationState(true);
        this.stateService.updateAssignment(true);

        this.formService.update$.subscribe(() => {
            this.source = {
                url: `${environment.api}/opdrachtformulieren/${this.formCode}/pdf/gevuld`,
                httpHeaders: {
                    Authorization: `Bearer ${this.auth.getToken()}`
                }
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next(false);
    }

}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/assignment-pvb/signing/signing.component.ts